import { fontWeights } from "@/utils/fonts";
import { HeroImageBanner } from "./HeroImageBanner";

export function Hero({
  locationName,
  serviceName,
  title,
  description: cmsDescription,
  images,
  data
}: {
  locationName?: string;
  serviceName?: string;
  title?: string;
  description?: string;
  images?: string[];
  data?: any;
}) {
  const replaceDynamicPlaceholders = (text?: string) => {
    if (!text) return text;
    return text
      .replace(/{location}/g, locationName || '')
      .replace(/{service}/g, serviceName || '');
  };

  const finalTitle = replaceDynamicPlaceholders(title || data?.title);
  const finalDescription = replaceDynamicPlaceholders(cmsDescription || data?.description);
  const finalImages = images || data?.images;

  // If there's no content at all, don't render the container, images, or bottom line
  if (!finalTitle && !finalDescription) {
    return null;
  }

  return (
    <>
      <HeroImageBanner images={finalImages} />
      <div
        className="
        relative
        bg-white
        pt-[10px]
        lg:pt-[20px]
        mx-auto
        max-w-[1920px]
        h-auto
        tsm-350:max-h-[495px]
        "
      >
        <div className=" ">
          <div className="text-center">
            <h1
              className="
              mx-auto
              text-[24px] 
              lg:text-[35px] 
              2xl:text-[40px] 
              3xl:text-[45px] 
              tracking-normal
              text-[#000000]
              px-4
              tsm-350:px-[40px]
              tsm-400:px-[70px]
              sm:px-[110px]
              md:px-[180px]
              lg:px-[60px]
              2xl:px-[10px]
              max-w-[810px]
              h-auto
              max-h-[600px]
              "
              style={{ fontFamily: 'Lato', fontWeight: fontWeights.lato.semiBold, lineHeight: "1.2" }}
            >
              {finalTitle && <span dangerouslySetInnerHTML={{ __html: finalTitle }} />}
            </h1>
            <p
              className="
              mt-6 
              lg:mt-[53px]
              leading-[20px]
              lg:leading-[25px]
              2xl:leading-[30px] 
              text-[#000000]
              w-auto
              max-w-[1101px]
              h-auto
              xl:h-[120px]
              max-h-[700px] 
              mx-auto
              text-[14px]
              lg:text-[20px]
              px-4
              sm:px-[35px]
              lg:px-[20px]
              "
              style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.regular }}
            >
              {finalDescription}
            </p>
          </div>
        </div>
      </div>
      <div className=" lg:py-[93px] sm:py-[60px] tsm-350:py-[40px] py-[45px]">
        <div className="lg:h-[1px] h-[0.99px] lg:w-[200px] w-[150px] bg-[#002F6D] mx-auto" />
      </div>
    </>
  );
}
